import axios from 'axios';
import config from '../config';

interface AddToWaitlistParams {
  language: string;
  user: {
    email?: string;
    given_name?: string;
    family_name?: string;
  };
  token: string;
}

interface WaitlistPayload {
  firstName: string;
  lastName: string;
  email: string;
  organizationName: string;
  programmingLanguages: string[];
  moreInfo: string;
  agreeToSendEmail: boolean;
}

/**
 * Add user to waitlist
 * @param {AddToWaitlistParams} params - User details, language, and access token
 * @returns {Promise<boolean>} - Success status
 */
export async function addToWaitlist({ language, user, token }: AddToWaitlistParams): Promise<boolean> {
  console.log(user.email, user.given_name, user.family_name, language);
  if (!user.email) {
    console.error('Missing required user information for waitlist');
    return false;
  }

  const waitlistPayload: WaitlistPayload = {
    firstName: user.given_name ?? '',
    lastName: user.family_name ?? '',
    email: user.email,
    organizationName: user.email.split('@')[1],
    programmingLanguages: [language],
    moreInfo: "added to waitlist from webapp setup page",
    agreeToSendEmail: true,
  };

  try {
    await axios.post(`${config.WAITLIST.API_URL}/production/leads`, waitlistPayload, {
      headers: {
        'authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    return true;
  } catch (error) {
    console.error(`Failed to add user to ${language} waitlist:`, error);
    return false;
  }
}
